import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Box,
  TableHead,
  Skeleton
} from '@mui/material';
import API from 'common/api';
import {
  useLocation, useParams,
} from 'react-router';
import { PlaceHolderText } from 'components/PlaceholderCard/PlaceholderCard';
import Progress from 'components/Progress/Progress';
import useList from 'hooks/useList';
import { Card, ExternalLink, Typography } from 'bso-ui';
import switchList from './switchList';
import SwitchStatus from './SwitchStatus';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3)
  }
}));

const SwitchContent = () => {
  const classes = useStyles();
  const { id } = useParams();
  const height = '100vh';
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const switchPaths = switchList.map((item) => item.id);

  const query = {
    storeKey: `switches-${id}`,
    apiEndpoint: `${API.DEVICE}?limit=50&type=switch&is_active=true`,
  };
  const [{
    data, isLoading, isError, isFetched
  }] = useList(query.storeKey, query.apiEndpoint, params);

  let filteredResults = [];
  if (id && switchPaths.includes(id) && !isLoading && data && data.results?.length > 0) {
    const category = switchList.find((item) => item.id === id);
    switch (category.name) {
      case 'Enyx-NJ':
        filteredResults = data.results.filter(
          (item) => item.hostname?.includes('.MAW') || item.hostname?.includes('.EWR')
        );
        break;
      case 'Enyx-Chicago':
        filteredResults = data.results.filter((item) => item.hostname?.includes('.CHI'));
        break;
      case 'Enyx-Toronto':
        filteredResults = data.results.filter((item) => item.hostname?.includes('.YTO'));
        break;
      default:
        break;
    }
  }

  const getCympaLink = (deviceName) => `https://mdb.cympa.io/d/rf-switches-metamako/rf-switches-metamako?var-device=${deviceName}`;

  if (!id || !switchPaths.includes(id)) {
    return (
      <div style={{ height: `calc(${height} - 100px)` }}>
        <PlaceHolderText variant="h3" content="Select feed" height="100%" />
      </div>
    );
  }

  if (isError) {
    return (
      <div style={{ height: `calc(${height} - 100px)` }}>
        <PlaceHolderText variant="h3" content="Error getting switches" height="100%" />
      </div>
    );
  }

  const renderData = () => (
    <Card id="SwitchesCard">
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><Typography variant="subtitle1">Hostname</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Ping</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Api</Typography></TableCell>
            </TableRow>
          </TableHead>
          {isFetched ? (
            <TableBody>
              {filteredResults.map((item) => (
                <TableRow
                  className={classes.tableRow}
                  hover
                  key={item.id}
                >
                  <TableCell>
                    <ExternalLink disableUnderline href={getCympaLink(item.hostname)}>
                      <Typography color="#5959ea" variant="body2">
                        {item.hostname}
                      </Typography>
                    </ExternalLink>
                  </TableCell>
                  <SwitchStatus type="PING" hostname={item.hostname} />
                  <SwitchStatus type="API" hostname={item.hostname} />
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              {[...Array(10)].map((item, index) => (
                <TableRow
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                >
                  <TableCell><Skeleton /></TableCell>
                  <TableCell><Skeleton /></TableCell>
                  <TableCell><Skeleton /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </CardContent>
    </Card>
  );

  return (
    <div className={classes.root}>
      <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
        <Typography id="SwitchesTitle" variant="h2" color="primary">Switches_</Typography>
        <span style={{ flex: 1 }} />
      </Toolbar>
      {!isLoading && id && data
        ? (
          <Box p={3}>
            {renderData()}
          </Box>
        ) : <Progress />}

    </div>
  );
};

export default SwitchContent;
